export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11267.f84aa240.jpg";